<template>

<div class="page work">

  <!-- MAIN LANDING SECTION -->
  <transition name="slide-up-in" appear>
	<section id="landing" class="block-image-hero">
		<div class="container">
			<span class="hero-background"></span>
			<ts-image :src="image1.url" :width="image1.size[0]" :height="image1.size[1]" :bg-color="image1.bgColor"></ts-image>
		</div>
	</section>
  </transition>


	<!-- TEXT -->
	<section id="section-1" class="block-text-overview">
		<div class="container">
			<div class="row">
				<div class="col-xs-12 col-sm-12 offset-md-4 col-md-7 offset-lg-5 col-lg-5" data-sal="slide-up" data-sal-delay="600" data-sal-duration="600" data-sal-easing="ease">
					<p class="meta">UX, UI &amp; Brand</p>
					<h2>ShowCode.</br>Contests</h2>
					<p>ShowCode is a modern day web application targeted at developers (students &amp; professionals alike) to enter and compete in coding contests. There is also a strong emphasis on ‘community’ whereby ShowCode hosts events and shares informative content.</p>
					<p>I worked closely with ShowCode to create the initial foundation of the platform, from how feature development can be flexible and scalable, communicating KPIs to ShowCode partners and sponsors along with the initial branding concept.</p>
				</div>
			</div>
		</div>
	</section>


	<!-- IMAGE -->
	<section id="section-2" class="block-image" data-sal="slide-up" data-sal-delay="0" data-sal-duration="600" data-sal-easing="ease">
		<div class="container">
			<!-- IMAGE 2 -->
			<ts-image :src="image2.url" :width="image2.size[0]" :height="image2.size[1]" :bg-color="image2.bgColor" dark-loader></ts-image>
		</div>
	</section>


	<!-- TEXT -->
	<section id="section-3" class="block-text-content border">
		<div class="container">
			<div class="row">
				<div class="col-xs-12 col-sm-12 offset-md-4 col-md-7 offset-lg-5 col-lg-4" data-sal="slide-up" data-sal-delay="0" data-sal-duration="600" data-sal-easing="ease">
					<h3>Player Profile Building</br>&amp; Development</h3>
					<p>Entering contests for prizes is a simple idea to understand for players but we needed to find a solution to help create loyalty beyond prizes.</p>
					<p>A simple, organic profile building tool allows the player to capture their personality, skills and interests. This includes an achievement system that invokes personal development as a developer. How to solve problems quickly, creatively with quality and consistency.</p>
				</div>
			</div>
		</div>
	</section>


	<!-- IMAGES -->
	<section id="section-4" class="block-image multiple">
		<div class="container">
			<span class="background right"></span>
			<!-- IMAGE 3 -->
			<ts-image :src="image3.url" :width="image3.size[0]" :height="image3.size[1]" :bg-color="image3.bgColor"></ts-image>
			<!-- IMAGE 4 -->
			<ts-image :src="image4.url" :width="image4.size[0]" :height="image4.size[1]" :bg-color="image4.bgColor"></ts-image>
		</div>
		<!-- DOWN ARROW -->
		<div class="down-arrow"></div>
	</section>


	<!-- TEXT -->
	<section id="section-5" class="block-text-content">
		<div class="container">
			<div class="row">
				<div class="col-xs-12 col-sm-12 offset-md-4 col-md-7 offset-lg-5 col-lg-4" data-sal="slide-up" data-sal-delay="0" data-sal-duration="600" data-sal-easing="ease">
					<h3>Competing in Contests</h3>
					<p>Contests need to be relatable to the developers prefered language and interests and are designed to be flexible, to improve personal development and act as a form of validation.</p>
          <p>Players can easily search for contests and explore what prizes and challenges await.</p>
				</div>
			</div>
		</div>
	</section>

  <!-- IMAGES -->
	<section id="section-4" class="block-image multiple">
		<div class="container">
			<span class="background right"></span>
			<!-- IMAGE 5 -->
			<ts-image :src="image5.url" :width="image5.size[0]" :height="image5.size[1]" :bg-color="image5.bgColor"></ts-image>
			<!-- IMAGE 6 -->
			<ts-image :src="image6.url" :width="image6.size[0]" :height="image6.size[1]" :bg-color="image6.bgColor"></ts-image>
			<!-- IMAGE 7 -->
			<ts-image :src="image7.url" :width="image7.size[0]" :height="image7.size[1]" :bg-color="image7.bgColor"></ts-image>
		</div>
		<!-- DOWN ARROW -->
		<div class="down-arrow"></div>
	</section>


	<!-- TEXT -->
	<section id="section-7" class="block-text-content">
		<div class="container">
			<div class="row">
				<div class="col-xs-12 col-sm-12 offset-md-4 col-md-7 offset-lg-5 col-lg-4" data-sal="slide-up" data-sal-delay="0" data-sal-duration="600" data-sal-easing="ease">
					<h3>Contests &amp; </br>Player Insights</h3>
					<p>If players join contests hosted by ShowCode partners, they can consent to be contacted by the partner to engage in potential employment conversation. This is a great and fun way for both the players and sponsors to engage.</p>
					<p>The initial first release of the partner portal measures both the engagement of contests to the performance of related player profiles.</p>
				</div>
			</div>
		</div>
	</section>


	<!-- IMAGE -->
	<section id="section-8" class="block-image">
		<!-- IMAGE 8 -->
		<ts-image :src="image8.url" :width="image8.size[0]" :height="image8.size[1]" :bg-color="image8.bgColor"></ts-image>
	</section>


	<ts-footer></ts-footer>

</div>


</template>


<script>

// @ is an alias to /src
import sal from 'sal.js'
import TsImage from '@/components/TSImage.vue'
import TsFooter from '@/components/TSFooter.vue'

import Image1 from "@/assets/images/works/showcode/600-image-1.png"
import Image2 from "@/assets/images/works/showcode/600-image-2.png"
import Image3 from "@/assets/images/works/showcode/600-image-3.png"
import Image4 from "@/assets/images/works/showcode/600-image-4.png"
import Image5 from "@/assets/images/works/showcode/600-image-5.png"
import Image6 from "@/assets/images/works/showcode/600-image-6.png"
import Image7 from "@/assets/images/works/showcode/600-image-7.png"
import Image8 from "@/assets/images/works/showcode/600-image-8.png"

export default {

  name: 'WorksShowCode',

  data() {
    return {
      image1: {
				url: Image1,
				size: [2560,1356],
				bgColor: "none"
			},
      image2: {
				url: Image2,
				size: [2560,1662],
				bgColor: "none"
			},
      image3: {
				url: Image3,
				size: [2560,2076],
				bgColor: "none"
			},
      image4: {
				url: Image4,
				size: [2560,2730],
				bgColor: "none"
			},
      image5: {
				url: Image5,
				size: [2560,2024],
				bgColor: "none"
			},
      image6: {
				url: Image6,
				size: [2560,2730],
				bgColor: "none"
			},
      image7: {
				url: Image7,
				size: [2560,2730],
				bgColor: "none"
			},
      image8: {
				url: Image8,
				size: [2560,2022],
				bgColor: "none"
			}
    }
  },

  components: {
    TsImage,
		TsFooter
  },

  mounted() {
    this.$root.$emit('show-shapes', false)
    sal({threshold: 0.10});
  }

}

</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

@import "~@/assets/scss/_variables";
@import "~@/assets/scss/grid/_bootstrap-grid";

span.hero-background {
	background-color: #181818;
}
span.background {
	background-color: #181818;
}

</style>
